import { gql } from '@apollo/client';

/**
 * Центр уведомлений сотрудника (ТЗ 0068).
 *
 * Два запроса, а не один, и это осознанно. Счётчик опрашивается раз в минуту
 * у каждого сотрудника — тянуть в нём ленту дорого. Разойтись они при этом не
 * могут: сервер строит обе выборки одной функцией с одним набором аргументов,
 * а `unreadCount` приходит и в ответе ленты, поэтому в момент открытия попапа
 * число и список взяты из ОДНОГО запроса.
 *
 * Имена операций (`NotificationBadge`, `NotificationFeed`) намеренно не
 * совпадают с именами полей: иначе codegen схлопывает тип результата в
 * payload схемы.
 */
export const NotificationBadgeQuery = gql`
  query NotificationBadge {
    staffNotificationsSummary {
      unreadCount
      totalCount
      latestId
      latestCreatedAt
      pollSeconds
      soundAlarm {
        active
        taskId
        title
      }
    }
  }
`;

export const NotificationFeedQuery = gql`
  query NotificationFeed($first: Int, $after: String, $unreadOnly: Boolean) {
    staffNotifications(first: $first, after: $after, unreadOnly: $unreadOnly) {
      unreadCount
      hasNextPage
      endCursor
      edges {
        cursor
        node {
          id
          kind
          title
          body
          taskId
          priority
          dueDate
          actorName
          createdAt
          readAt
        }
      }
    }
  }
`;

export const NotificationPrefsQuery = gql`
  query NotificationPrefs {
    staffNotificationSettings {
      soundEnabled
      pollSeconds
      repeatAfterMinutes
      quietFrom
      quietTo
      enabledKinds
      availableKinds {
        key
        label
        enabled
      }
      telegramEnabled
      telegramLinked
      telegramUsername
      telegramLinkedAt
      telegramBlockedAt
      telegramAvailable
      robotRules
      availableRobotRules {
        key
        label
        enabled
        available
      }
    }
  }
`;
